import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    FormControl,
    FormLabel,
} from '@chakra-ui/react';
import CustomSelect from 'components/CustomSelect';

/**
 * RepeatModal - Reusable modal for setting repeat frequency.
 * @param {object} props
 * @param {boolean} props.isOpen - Modal open state
 * @param {function} props.onClose - Close handler
 * @param {object} [props.value] - Repeat values {frequency}
 * @param {function} [props.onChange] - Change handler for fields
 * @param {function} [props.onSet] - Handler for Set Repeat button
 */
function RepeatModal({ isOpen, onClose, value = {}, onChange, onSet }) {
    const frequencyOptions = [
        { label: 'Daily', value: 'DAILY' },
        { label: 'Weekly', value: 'WEEKLY' },
        { label: 'Monthly', value: 'MONTHLY' },
    ];
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
            <ModalOverlay />
            <ModalContent borderRadius="lg">
                <ModalHeader fontWeight="bold">Repeat</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl mb={8}>
                        <FormLabel>Frequency</FormLabel>
                        <CustomSelect
                            name="frequency"
                            options={frequencyOptions}
                            placeholder="Frequency"
                            value={value.frequency || ''}
                            onChange={(val) => {
                                onChange({
                                    target: { name: 'frequency', value: val?.target?.value },
                                });
                            }}
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button color="white" bg="#1b3b5f" mr={3} onClick={onSet}>
                        Set Repeat
                    </Button>
                    <Button color="#1b3b5f" bg="#B8C1D380" onClick={onClose}>
                        Cancel
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default RepeatModal;
